import React from "react";
import { Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface CatalogForbiddenProps {
  onSignOut: () => void;
}

const CatalogForbidden: React.FC<CatalogForbiddenProps> = ({ onSignOut }) => {
  const { t } = useTranslation();

  return (
    <Alert variant="warning">
      <Alert.Heading>{t("catalog.forbidden.title")}</Alert.Heading>
      <p>{t("catalog.forbidden.body")}</p>
      <Button variant="outline-dark" onClick={onSignOut}>
        {t("catalog.forbidden.signOut")}
      </Button>
    </Alert>
  );
};

export default CatalogForbidden;
